import MyIcon from '@/components/MyIcon';
import { CheckOutlined } from '@ant-design/icons';
import ToastUtils from '@/utils/ToastUtils';
import { useState } from 'react';
import { Tooltip } from 'antd';
const Copy = (props) => {
    const { side = 'web', className, onClick } = props;
    const [copySuccess, setCopySuccess] = useState(false);
    const copyClick = (e) => {
        if (onClick) {
            onClick(e);
        }
        if (side === 'web') {
            setCopySuccess(true);

            setTimeout(() => {
                setCopySuccess(false);
            }, 6000);
        }
        if (side === 'mobile') {
            ToastUtils.showToast('已复制');
        }
    };
    return (
        <>
            {copySuccess ? (
                <Tooltip zIndex={1} title={side === 'web' ? '已复制' : null}>
                    <span className={className}>
                        <CheckOutlined className="ai-action-icon" style={{ color: '#52C41A' }} />
                    </span>
                </Tooltip>
            ) : (
                <Tooltip zIndex={1} title={side === 'web' ? '复制' : null}>
                    <span onClick={copyClick} className={className}>
                        <MyIcon className="ai-action-icon" type="icon-code-copy"></MyIcon>
                    </span>
                </Tooltip>
            )}
        </>
    );
};

export default Copy;
